export const viewport = (): { vw: number; vh: number } => {
	const vw = window.innerWidth || 0;
	const vh = window.innerHeight || 0;
	return { vw, vh };
};
